<script>
    import { _ } from "../services/i18n";
    import { getImages, getImageUrl } from "../services/images";
    import ImageUploadDialog from "./ImageUploadDialog.svelte";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let value = "";

    let images = [];
    let pickImageDialog = null;
    let showUploadDialog = null;

    let selectedImage = null;

    const showPickImageDialog = async () => {
        images = await getImages();
        selectedImage = images.find(img => getImageUrl(img) === value);
        pickImageDialog.showModal();
    }
    
    const onNewImageUploaded = async (evt) => {
        images = await getImages();
        const newImageId = evt.detail?.id;
        if (newImageId) {
            selectedImage = images.find(img => img.id === newImageId);
        }
    }

    const uploadNewImage = () => {
        showUploadDialog();
    }
    
    const pickImage = () => {
        pickImageDialog.close();
        value = getImageUrl(selectedImage);
        dispatch("imagePicked", selectedImage);
    }

    const clearImage = () => {
        value = "";
        dispatch("imagePicked", null);
    }

</script>

<ImageUploadDialog bind:show={showUploadDialog} on:imageUpdated={onNewImageUploaded} maxSize=500 />

<dialog bind:this={pickImageDialog} class="image-picker">
    <section>
        <h1>{$_('ui_dialogs_selectImage_title')}</h1>
        <ul>
            {#each images as image}
                <li 
                    on:click={() => selectedImage = image} 
                    on:keyup={() => selectedImage = image}
                    class={image === selectedImage ? "selected" : ""}>
                    <span>{image.name}</span>
                    <img src={getImageUrl(image)} class="checkered-background" alt={image.name} />
                </li>
            {/each}
        </ul>
        <footer>
            <button on:click={() => uploadNewImage()}>{$_('ui_buttons_uploadNewImage')}</button>
            <button on:click={() => pickImage()}  disabled={selectedImage === null}>{$_('ui_buttons_selectImageButton')}</button>
            <button on:click={() => pickImageDialog.close()}>{$_('ui_buttons_cancel')}</button>
        </footer>
    </section>
</dialog>

<article>
    {#if value !== "" && value !== null && value !== undefined}
        <img src={value} class="checkered-background" alt="Current selection" />
    {:else}
        <img src="icons/image-picker-icon.svg" class="checkered-background" alt="No selection placeholder" />
    {/if}

    <button on:click={showPickImageDialog}>{$_('ui_buttons_selectImageButton')}</button>
    {#if value !== "" && value !== null && value !== undefined}
        <button on:click={clearImage}>{$_('ui_buttons_clearImageButton')}</button>
    {/if}
</article>

<style>
    article {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        width: 200px;
        min-height: 200px;
        padding: 10px;
        gap: 9px;
        border: 1px solid #aaa;
        border-radius: 5px;
    }
        
    article button {
        margin: 0;
    }
</style>

<svelte:head>
    <link rel="stylesheet" href="styles/ui/image-picker.css" />
</svelte:head>